import { StyleSheet, css } from 'aphrodite';
import Wkt from 'wicket';
import GoogleMapReact from 'google-map-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { fetchReaZipBoundaries } from '../../utils/Fetch/Agent';
import { COLORS } from '../../config/themes';

const GoogleMap = (props) => {
  const {
    passedCenter,
    agent,
    skipGeos,
    mapContainerStyles,
    children,
    options,
    noKey,
    onDragEnd,
    mapRef,
  } = props;
  const [geosReady, setGeosReady] = useState(false);

  const uuidRef = useRef(uuidv4());

  const handleApiLoaded = (map, maps) => {
    if (mapRef) mapRef.current = map;
    if (!skipGeos) {
      fetchReaZipBoundaries({ agent_id: agent.agent_id }).then(async (geos) => {
        await addMapBoundaries(map, geos).then(setGeosReady(true));
      });
    }
  };

  const addMapBoundaries = async (map, geos) => {
    if (geos && geos.length > 0 && agent.prime !== null) {
      const wkt = new Wkt.Wkt();
      const featureStyleOptions = {
        strokeColor: COLORS.PRIMARY_ACTION(),
        strokeOpacity: 0,
        strokeWeight: 0,
        fillColor: COLORS.PRIMARY_ACTION(),
        fillOpacity: 0.4,
      };
      const collection = {
        type: 'FeatureCollection',
        features: [],
      };
      const featureUnions = [];

      for (let i = 0; i < geos.length; i++) {
        const geo = geos[i];
        let wktString = geo.geom;

        if (typeof wktString === 'string') {
          wktString = wktString.trim().replace(/"+$/, '');
        } else {
          console.warn(
            `Skipping non-string geom for postcode ${geo.postcode || 'N/A'}`,
          );
          continue;
        }

        try {
          wkt.read(wktString);
          const geometry = wkt.toJson();
          const feature = { type: 'Feature', geometry };
          featureUnions.push(feature);
        } catch (e) {
          console.error(
            `Skipping invalid WKT geom for postcode ${geo.postcode || 'N/A'}: ${e.message}`,
          );
        }
      }

      collection.features = featureUnions;

      if (collection.features.length > 0) {
        map.data.addGeoJson(collection);
        map.data.setStyle(featureStyleOptions);
      } else {
        console.log('No valid geometries found to add to the map.');
      }
    }
  };

  return (
    <div className={css(styles.mapContainer, mapContainerStyles)}>
      {!geosReady && !skipGeos && (
        <div className={css(styles.overlayContainer)}>
          <div className={css(styles.overlay)} />
          <FontAwesomeIcon
            className={css(styles.loader)}
            icon={faSpinnerThird}
            spin
          />
        </div>
      )}
      <GoogleMapReact
        bootstrapURLKeys={
          noKey ? null : { key: 'AIzaSyAhCkJXl-CJIM1m8XplB7mOdi_YMI077e4' }
        }
        center={passedCenter}
        defaultCenter={passedCenter}
        defaultZoom={9}
        options={options}
        onDragEnd={onDragEnd}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
      >
        {children}
      </GoogleMapReact>
    </div>
  );
};

const styles = StyleSheet.create({
  mapContainer: {
    display: 'flex',
    width: '100%',
    height: 350,
    marginTop: 20,
    position: 'relative',

    '@media only screen and (max-width: 1439px)': {
      height: 300,
    },
    '@media only screen and (max-width: 767px)': {
      height: 250,
    },
    '@media only screen and (max-width: 424px)': {
      height: 180,
    },
  },
  overlayContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background: COLORS.BLACK(0.3),
  },
  loader: {
    '--fa-primary-color': '#eee',
    '--fa-primary-opacity': 1,
    fontSize: 45,
    zIndex: 2,
  },
});

export default GoogleMap;
